import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  dialogContainer: {
    overflow: 'visible',

    '& > *': {
      overflow: 'visible',
    },
  },
  dialogBody: {
    position: 'relative',
    width: 500,

    [theme.fn.smallerThan('sm')]: {
      padding: theme.other.spacing._16,
      width: `calc(100vw - ${theme.other.spacing._16 * 2}px)`,
    },

    overflow: 'visible',
  },
  dialogGradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 100,
    background: 'linear-gradient(180deg, rgba(202, 202, 202, 0.5) 0%, #FFF 100%)',
    borderTopLeftRadius: theme.other.spacing._24,
    borderTopRightRadius: theme.other.spacing._24,
    zIndex: 1,
  },

  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._16,
    zIndex: 2,
  },

  badge: {
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ -100,
  },

  description: {
    color: theme.colors.gray2[4],
    textAlign: 'center',
    maxWidth: 300,
  },

  progressSection: {
    width: 325,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
  },
  progressLabelRow: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.other.spacing._8,
  },
  progressLabel: {
    color: theme.colors.gray2[6],
  },
  progressCount: {
    flexShrink: 0,
    color: theme.colors.gray2[6],
  },
  progressTrack: {
    position: 'relative',
    width: '100%',
    height: 6,
    background: theme.colors.gray[1],
    borderRadius: theme.radius.lg,
  },
  progressBarFill: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 6,
    minWidth: 12,
    background: 'linear-gradient(90deg, #10625D 0%, #59D0C9 202.25%), #F1F3F5',
    borderRadius: theme.radius.lg,
  },

  endsIn: {
    color: theme.colors.gray2[3],
    textAlign: 'center',
  },

  cta: {
    width: '100%',
  },

  terms: {
    width: '100%',
  },
  termsContent: {
    color: theme.colors.gray2[6],
  },

  accordion: {},
  accordionItem: {
    borderBottom: 'none',
  },
  accordionControl: {
    width: 'auto',
    margin: '0 auto',
    borderRadius: theme.radius.sm,
    padding: `${theme.other.spacing._4}px ${theme.other.spacing._16}px`,
    color: theme.colors.gray2[3],

    '& .mantine-Accordion-chevron': {
      marginLeft: theme.other.spacing._4,
    },
  },
  accordionPanel: {
    '& .mantine-Accordion-content': {
      padding: 0,
    },
  },
}));
